module.exports = __webpack_public_path__ + "img/logo.55d1e7a8.png";